import { render, staticRenderFns } from "./ProfileConfigPage.vue?vue&type=template&id=6685532a&scoped=true"
import script from "./ProfileConfigPage.vue?vue&type=script&lang=ts"
export * from "./ProfileConfigPage.vue?vue&type=script&lang=ts"
import style0 from "./ProfileConfigPage.vue?vue&type=style&index=0&id=6685532a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685532a",
  null
  
)

export default component.exports